let publicKey = null; // 로그인 계정 공개키
export function setPublicKey(key) {
    publicKey = key;
}
export function getPublicKey() {
    return publicKey;
}